import {
  AppWindowIcon,
  PanelRightIcon,
  PictureInPicture01Icon,
  Moon02Icon,
  Sun03Icon,
  Add01Icon,
  Alert02Icon,
  Archive03Icon,
  ArrowDown01Icon,
  ArrowLeft01Icon,
  ArrowLeft02Icon,
  ArrowRight01Icon,
  ArrowUp01Icon,
  ArrowLeftRightIcon,
  Attachment01Icon,
  BellDotIcon,
  BookOpenTextIcon,
  BotIcon,
  CheckListIcon,
  CheckmarkBadge01Icon,
  FileEditIcon,
  LeftToRightListBulletIcon,
  Camera01Icon,
  CameraVideoIcon,
  Calendar03Icon,
  CalendarUserIcon,
  CalendarCheckIcon,
  CancelIcon,
  CellsIcon,
  Chart03Icon,
  Chat01Icon,
  ChatAddIcon,
  ChatDoneIcon,
  CheckmarkCircle02Icon,
  CircleIcon,
  CircleSmallIcon,
  Cursor01Icon,
  CopyIcon,
  Crown03Icon,
  Clock04Icon,
  DashboardSquare01Icon,
  DeleteIcon,
  Doc01Icon,
  Download05Icon,
  DriveIcon,
  DragDropVerticalIcon,
  Edit03Icon,
  Ellipsis,
  File01Icon,
  Files01Icon,
  FileUploadIcon,
  Upload01Icon,
  FilterIcon,
  Folder01Icon,
  Folder02Icon,
  FolderLibraryIcon,
  FolderShared02Icon,
  GlobeIcon,
  HelpCircleIcon,
  HelpSquareIcon,
  ImageAdd02Icon,
  ImageIcon,
  InformationCircleIcon,
  LanguageSkillIcon,
  Link04Icon,
  LinkSquare02Icon,
  Loading02Icon,
  MagicWand05Icon,
  MapPinIcon,
  MaximizeScreenIcon,
  MinimizeScreenIcon,
  MonitorPauseIcon,
  MouseScroll01Icon,
  CarouselVerticalIcon,
  Mic02Icon,
  MentoringIcon,
  NoteIcon,
  PanelLeftCloseIcon,
  PanelLeftOpenIcon,
  PlayCircleIcon,
  PrinterIcon,
  Projector01Icon,
  QrCodeIcon,
  ReloadIcon,
  RemoveSquareIcon,
  SentIcon,
  Robot01Icon,
  School01Icon,
  Search01Icon,
  ScanIcon,
  Settings01Icon,
  Share01Icon,
  ShareKnowledgeIcon,
  SolidLine01Icon,
  SparklesIcon,
  SquareLock02Icon,
  SquareArrowDown01Icon,
  StopCircleIcon,
  StickyNote03Icon,
  StudentsIcon,
  Tick02Icon,
  TimeQuarter02Icon,
  ThumbsDownIcon,
  ThumbsUpIcon,
  TwoSquareIcon,
  Undo03Icon,
  User03Icon,
  UserGroupIcon,
  UserAdd01Icon,
  UserRemove02Icon,
  ViewIcon,
  ViewOffIcon,
  Watch01Icon,
  YoutubeIcon,
  FolderAddIcon,
  FunctionIcon,
  ArrowDiagonalIcon,
  ArrowShrink02Icon,
  MinusSignIcon,
  TestTube01Icon,
  LeftToRightListNumberIcon,
  TextBoldIcon,
  TextItalicIcon,
  TextUnderlineIcon,
  TextStrikethroughIcon,
  Heading01Icon,
  Heading02Icon,
  Heading03Icon,
  ParagraphIcon,
  TextFontIcon,
  TextColorIcon,
  HighlighterIcon,
  TextClearIcon,
  TextAlignLeftIcon,
  TextAlignCenterIcon,
  TextAlignRightIcon,
  TextAlignJustifyCenterIcon,
  TextField,
  SignatureIcon,
  ShieldKeyIcon,
  ShieldUserIcon,
  SecurityCheckIcon,
  Copy02Icon,
} from '@hugeicons/core-free-icons';

import type { Component } from 'vue';
import CalendarEye from './icons/calendar-eye.svg?component';
import CalendarPencil from './icons/calendar-pencil.svg?component';

/* eslint-disable @typescript-eslint/naming-convention */

type IconSvgObject =
  | [string, Record<string, string | number>][]
  | readonly (readonly [string, Readonly<Record<string, string | number>>])[];

// Central mapping of icon names to Hugeicons definitions. Extend here when adding new icons.
const Icons = {
  mouse_scroll: MouseScroll01Icon,
  carousel_vertical: CarouselVerticalIcon,
  monitor_pause: MonitorPauseIcon,
  moon: Moon02Icon,
  sun: Sun03Icon,
  warning: Alert02Icon,
  info: InformationCircleIcon,
  magic_wand: MagicWand05Icon,
  qr_code: QrCodeIcon,
  image: ImageIcon,
  eye_open: ViewIcon,
  eye_closed: ViewOffIcon,
  bell_dot: BellDotIcon,
  drive_file: DriveIcon,
  copy: CopyIcon,
  crown: Crown03Icon,
  edit: Edit03Icon,
  delete: DeleteIcon,
  ellipsis: Ellipsis,
  left_panel_open: PanelLeftOpenIcon,
  left_panel_close: PanelLeftCloseIcon,
  folder: Folder01Icon,
  folder_open: Folder02Icon,
  plus: Add01Icon,
  circle: CircleIcon,
  circle_small: CircleSmallIcon,
  scan: ScanIcon,
  cursor: Cursor01Icon,
  watch: Watch01Icon,
  library: FolderLibraryIcon,
  close: CancelIcon,
  cancel: CancelIcon,
  robot: Robot01Icon,
  people: UserGroupIcon,
  students: StudentsIcon,
  cog: Settings01Icon,
  file: File01Icon,
  files: Files01Icon,
  chevron_up: ArrowUp01Icon,
  chevron_down: ArrowDown01Icon,
  chevron_left: ArrowLeft01Icon,
  chevron_right: ArrowRight01Icon,
  checkmark: Tick02Icon,
  grade_badge: CheckmarkBadge01Icon,
  note: NoteIcon,
  sticky_note: StickyNote03Icon,
  drag_vertical: DragDropVerticalIcon,
  attachment: Attachment01Icon,
  book_open_text: BookOpenTextIcon,
  language: LanguageSkillIcon,
  search: Search01Icon,
  filter: FilterIcon,
  file_upload: FileUploadIcon,
  download_05: Download05Icon,
  upload: FileUploadIcon,
  upload_plain: Upload01Icon,
  upload_file: FileUploadIcon,
  link: Link04Icon,
  youtube: YoutubeIcon,
  checkmark_circle: CheckmarkCircle02Icon,
  open_in_new: LinkSquare02Icon,
  question_mark_square: HelpSquareIcon,
  question_mark_circle: HelpCircleIcon,
  lock: SquareLock02Icon,
  share: Share01Icon,
  share_knowledge: ShareKnowledgeIcon,
  solid_line: SolidLine01Icon,
  evaluate: Chart03Icon,
  back: ArrowLeft02Icon,
  beta: TestTube01Icon,
  print: PrinterIcon,
  loading: Loading02Icon,
  calendar: Calendar03Icon,
  calendar_user: CalendarUserIcon,
  calendar_check: CalendarCheckIcon,
  camera: Camera01Icon,
  camera_video: CameraVideoIcon,
  bot: BotIcon,
  share_folder: FolderShared02Icon,
  dashboard: DashboardSquare01Icon,
  speech_bubble: Chat01Icon,
  chat_done: ChatDoneIcon,
  user: User03Icon,
  present: Projector01Icon,
  add_image: ImageAdd02Icon,
  sparkle: SparklesIcon,
  sparkles: SparklesIcon,
  undo: Undo03Icon,
  country: GlobeIcon,
  state: MapPinIcon,
  school: School01Icon,
  subject: CellsIcon,
  docx: Doc01Icon,
  file_edit: FileEditIcon,
  list_bullet: LeftToRightListBulletIcon,
  list_number: LeftToRightListNumberIcon,
  text_bold: TextBoldIcon,
  text_italic: TextItalicIcon,
  text_underline: TextUnderlineIcon,
  text_strikethrough: TextStrikethroughIcon,
  heading_1: Heading01Icon,
  heading_2: Heading02Icon,
  heading_3: Heading03Icon,
  text_paragraph: ParagraphIcon,
  text_font: TextFontIcon,
  text_color: TextColorIcon,
  text_highlighter: HighlighterIcon,
  text_clear: TextClearIcon,
  text_align_left: TextAlignLeftIcon,
  text_align_center: TextAlignCenterIcon,
  text_align_right: TextAlignRightIcon,
  text_align_justify: TextAlignJustifyCenterIcon,
  text_field: TextField,
  checklist: CheckListIcon,
  arrow_left_right: ArrowLeftRightIcon,
  function_square: FunctionIcon,
  play: PlayCircleIcon,
  reload: ReloadIcon,
  sent: SentIcon,
  history: Clock04Icon,
  chat_add: ChatAddIcon,
  app_window: AppWindowIcon,
  panel_right: PanelRightIcon,
  picture_in_picture: PictureInPicture01Icon,
  maximize_screen: MaximizeScreenIcon,
  minimize_screen: MinimizeScreenIcon,
  duration: TimeQuarter02Icon,
  maximize: ArrowDiagonalIcon,
  minimize: ArrowShrink02Icon,
  minus: MinusSignIcon,
  mic: Mic02Icon,
  stop: StopCircleIcon,
  person_add: UserAdd01Icon,
  remove_person: UserRemove02Icon,
  remove: RemoveSquareIcon,
  archive: Archive03Icon,
  square_arrow_down: SquareArrowDown01Icon,
  two_square: TwoSquareIcon,
  thumb_up: ThumbsUpIcon,
  thumb_down: ThumbsDownIcon,
  create_folder: FolderAddIcon,
  // for template icons - remove once we switched to huge icons
  question_mark: HelpCircleIcon,
  webinar: MentoringIcon,
  signature: SignatureIcon,
  encryption: ShieldKeyIcon,
  shield_user: ShieldUserIcon,
  shield_check: SecurityCheckIcon,
  merge: Copy02Icon,
  //********
} as const;

const CustomIcons = {
  calendar_eye: CalendarEye,
  calendar_pencil: CalendarPencil,
} as const;

export type Icon = keyof typeof Icons | keyof typeof CustomIcons;

export type IconProps = {
  icon: Icon;
  size?: number;
  spin?: boolean;
};

type ResolvedIcon =
  | { kind: 'hugeicon'; icon: IconSvgObject }
  | { kind: 'svg'; component: Component };

export const resolveIcon = (icon: Icon): ResolvedIcon =>
  icon in CustomIcons
    ? { kind: 'svg', component: CustomIcons[icon as keyof typeof CustomIcons] }
    : { kind: 'hugeicon', icon: Icons[icon as keyof typeof Icons] };

// Export list of available icon names for consumers (e.g., Storybook galleries)
export const iconNames = [
  ...Object.keys(Icons),
  ...Object.keys(CustomIcons),
] as Icon[];
